import React from 'react';
import useCopy, { stripMarkup } from '../useCopy';
import { LIFESTYLE } from '../assets';

const LONG_HEADLINE_LENGTH = 44;
const XL_HEADLINE_LENGTH = 60;

const getPurposeHeadlineClass = (headline) => {
  const length = stripMarkup(headline).length;
  if (length > XL_HEADLINE_LENGTH) return 'xl';
  if (length > LONG_HEADLINE_LENGTH) return 'long';
  return '';
};

export const PurposeSlide = ({ purpose }) => {
  const c = useCopy();
  const headline = c.variantText('PC_Purpose_Headline', purpose);
  const size = getPurposeHeadlineClass(headline);

  return (
    <div className="s-purpose">
      <img className="pc-img pur-photo" alt="" src={LIFESTYLE} />
      <div className="pur-shade" />
      <h2 className={`pur-head ${size}`}>{c.variantRich('PC_Purpose_Headline', purpose)}</h2>
    </div>
  );
};
